/**
 * @file The Purchase Album container.
 */

import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import { MeForAlbumPurchaseIdentities } from '../../graphql/queries/account';
import { AlbumDataWithParentAndSubscription } from '../../graphql/queries/albums';
import PurchaseAlbum from '../../components/purchase/PurchaseAlbum';
import { getAlbumMembership } from '../../util/account';

const withUserData = graphql(MeForAlbumPurchaseIdentities, {
  options: ({ match }) => ({
    variables: {
      albumId: match.params.albumId,
    },
  }),
  props: ({ data: { me, loading }, ownProps: { match } }) => ({
    user: me,
    albumMembership: getAlbumMembership(me, match.params.albumId),
    loading,
  }),
});

const withAlbumData = graphql(AlbumDataWithParentAndSubscription, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
  }),
  props: ({ data: { album, loading } }) => ({
    album,
    loadingAlbum: loading,
  }),
});

const mapStateToProps = ({ purchaseAlbumPhotos }) => ({
  selectedPhotos: purchaseAlbumPhotos.photos,
});

export default compose(
  withRouter,
  withUserData,
  withAlbumData,
  connect(mapStateToProps, null),
)(PurchaseAlbum);
